import { IntegrationSettingsSchema, type IntegrationProviders } from '@weft/types';
import { validateNotNullOrUndefined } from '@weft/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useIntegrationSettings(provider: IntegrationProviders) {
  const integrationSettingsResponse = useQuery(
    ['integrationSettings'],
    async () => {
      const privateApi = getPrivateApi();
      const { integrationSettings, integrationId } = await privateApi.getIntegrationsSettings({ provider });

      const parsedSettings = IntegrationSettingsSchema.parse(integrationSettings);

      return { integrationId, integrationSettings: parsedSettings };
    },
    { suspense: true },
  );

  validateNotNullOrUndefined(integrationSettingsResponse.data, 'integrationSettings');

  return integrationSettingsResponse;
}